import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

import Landing from '@/pages/Landing/index.vue'
import Dashboard from '@/pages/Dashboard/index.vue'
import TitleInfo from '@/pages/TitleInfo/index.vue'
import Fees from '@/pages/Fees/index.vue'
import Payoffs from '@/pages/Payoffs/index.vue'
import Preview from '@/pages/Preview/index.vue'
import Documents from '@/pages/Documents/index.vue'
import NotFound from '@/pages/NotFound/index.vue'
import LinkExpired from '@/pages/LinkExpired/index.vue'

const routes = [
  {
    path: '/access/:token',
    name: 'Landing',
    component: Landing,
    meta: { title: 'Accessing Title Portal' },
  },
  {
    path: '/demo',
    name: 'Demo',
    redirect: () => {
      // Set up demo data
      store.dispatch('setSession', {
        sessionToken: 'demo-token',
        settlementAgent: {
          id: 1,
          name: 'ABC Title Company',
          email: 'closing@abctitle.com',
          phone: '555-123-4567',
        },
        loan: {
          id: 12345,
          borrower_names: 'John Smith and Jane Smith',
          property: {
            address_line_1: '123 Main Street',
            city: 'Springfield',
            state: 'IL',
            zip_code: '62701',
          },
        },
        closingRequest: {
          id: 1,
          status: 'PENDING',
        },
      })
      store.dispatch('setLoanOfficer', {
        name: 'Mike Johnson',
        email: 'mike.johnson@lender.com',
        phone: '555-987-6543',
      })
      store.dispatch('setFees', [
        { id: 1, hud_line: '1101', name: 'Settlement Fee', amount: 450.00, payee: 'ABC Title Company', tolerance: '10%' },
        { id: 2, hud_line: '1108', name: 'Title Insurance', amount: 1250.00, payee: 'ABC Title Company', tolerance: '10%' },
      ])
      store.dispatch('setPayoffs', [
        { id: 1, creditor_name: 'First National Bank', account_number: '****1234', balance_due: 125000.00, per_diem: 25.50, expiration_date: '2026-01-15', type: 'Mandatory Obligation' },
        { id: 2, creditor_name: 'County Tax Office', account_number: 'TAX-2024', balance_due: 3500.00, per_diem: 0, expiration_date: '2026-02-01', type: 'Tax Payoff' },
      ])
      store.dispatch('setToleranceStatus', {
        has_violation: false,
        has_warning: false,
        sections: [
          { tolerance: '10%', disclosed_total: 2500.00, current_total: 1700.00, variance: 0, is_exceeded: false, is_warning: false },
        ],
      })
      store.dispatch('setClosingProgress', {
        titleInfoComplete: false,
        feesComplete: true,
        payoffsComplete: false,
        previewGenerated: false,
        documentsGenerated: false,
      })
      return { name: 'Dashboard' }
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: 'Closing Dashboard', requiresAuth: true },
  },
  {
    path: '/title-info',
    name: 'TitleInfo',
    component: TitleInfo,
    meta: { title: 'Vesting & Legal Description', requiresAuth: true },
  },
  {
    path: '/fees',
    name: 'Fees',
    component: Fees,
    meta: { title: 'Closing Fees', requiresAuth: true },
  },
  {
    path: '/payoffs',
    name: 'Payoffs',
    component: Payoffs,
    meta: { title: 'Payoffs', requiresAuth: true },
  },
  {
    path: '/preview',
    name: 'Preview',
    component: Preview,
    meta: { title: 'Document Preview', requiresAuth: true },
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents,
    meta: { title: 'Closing Documents', requiresAuth: true },
  },
  {
    path: '/link-expired',
    name: 'LinkExpired',
    component: LinkExpired,
    meta: { title: 'Link Expired' },
  },
  {
    path: '/',
    redirect: '/link-expired',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'Page Not Found' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard
router.beforeEach((to, from, next) => {
  // Update document title
  if (to.meta.title) {
    document.title = `${to.meta.title} - Closing Portal`
  }

  // Check authentication for protected routes
  if (to.meta.requiresAuth) {
    const sessionToken = localStorage.getItem('title_session_token')
    if (!sessionToken) {
      next({ name: 'LinkExpired' })
      return
    }
  }

  next()
})

export default router

